module.exports = __webpack_public_path__ + "img/error-illustration.3f229e3c.svg";